<template>
  <div class="home">
    <div class="home-box">
      <menuBox :step="1"></menuBox>
      <div class="text-box">
        <div>¡Explora comida deliciosa y descubre la diversión!</div>
        <!-- <p>615615615616</p> -->
        <div class="sb-text">Aquí, la comida deliciosa y las experiencias agradables se combinan a la perfección. Cada uno de nuestros puestos y restaurantes es un lugar animado y con un ambiente único donde compartir una comida, reír y charlar con familiares y amigos. En la atmósfera de entretenimiento y ocio, encontrará más diversión en todas partes: desde maravillosas actividades de entretenimiento hasta relajantes momentos de ocio, esperamos que cada visita le traiga maravillosos recuerdos y sensaciones.</div>
      </div>
    </div>
    <div class="way-box">
      <div class="way-text">
        <div class="title">Un festín para tu paladar y alegría ilimitada.</div>
        <div class="sbtitle">No solo ofrecemos comida exquisita, sino que también brindamos una nueva experiencia gastronómica. En nuestro ambiente cálido y acogedor, degustarás sabores únicos de todo el mundo, mezclando tradición e innovación en cada bocado. Ya sea una cena tranquila por la tarde o una guía de refrigerios de ritmo rápido, estamos comprometidos a brindarle un viaje delicioso e inolvidable.</div>
        <div class="way-info">
          <div class="item">
            <img src="../assets/home-3.png" alt="">
            <div class="item-text">
              <div>alimento</div>
              <p>Saludable, deliciosa y nutritiva</p>
            </div>
          </div>
          <div class="item">
            <img src="../assets/home-4.png" alt="">
            <div class="item-text">
              <div>bebidas</div>
              <p>Rico sabor y diversas opciones.</p>
            </div>
          </div>
        </div>
        <div class="gou-box">
          <img src="../assets/home-5.png" alt="">
          Fresco y de alta calidad
        </div>
        <div class="gou-box">
          <img src="../assets/home-5.png" alt="">
          Creativo y exquisito
        </div>
      </div>
      <img src="../assets/home-2.png" alt="">
    </div>

    <div class="cuisine-box">
      <div class="title">Un festín para el gusto, alegría ilimitada, cada bocado está lleno de felicidad.</div>
      <!-- <p class="ctetext">456156156</p> -->
      <div class="sbtitle">Bienvenidos a nuestro mundo, que no es sólo una fiesta de diversos gustos, sino también un viaje único de disfrute espiritual. La selección de platos y bebidas abarca desde cenas elegantes hasta comida rápida informal, y cada bocado se prepara cuidadosamente para brindarle una nueva experiencia de sabor. Comparta tiempo de calidad con familiares y amigos aquí, pruebe ingredientes frescos y condimentos únicos de todo el mundo, y cada comida será una interpretación perfecta de la infinita alegría y satisfacción de la vida.</div>
      <div class="cuisine-list">
        <div class="item item-box">
          <img src="../assets/home-6.png" alt="">
          <div>Herencia del gusto</div>
          <p>Cocina con mimo y disfruta de un delicioso festín.</p>
        </div>
        <div class="item">
          <img src="../assets/home-7.png" alt="">
          <div>Bebe los clásicos</div>
          <p>Colecciona vino tinto para añadir color a cada ocasión.</p>
        </div>
        <div class="item">
          <img src="../assets/home-8.png" alt="">
          <div>Diseño artístico</div>
          <p>La sofisticación occidental, la fusión perfecta entre gusto y disfrute.</p>
        </div>
        <div class="item item-box">
          <img src="../assets/home-9.png" alt="">
          <div>rico sabor</div>
          <p>Variedad de sabores añaden alegría a cada momento.</p>
        </div>
      </div>

      <div class="text-list">
        <div class="info">
          <div>96%</div>
          <p>la satisfacción del cliente</p>
        </div>
        <div class="info">
          <div>15+</div>
          <p>empresa de catering</p>
        </div>
        <div class="info">
          <div>832+</div>
          <p>Variedad de platos</p>
        </div>
        <div class="info">
          <div>68+</div>
          <p>estilo restaurante</p>
        </div>
      </div>

      <div class="text-title">
        <div class="title">Añade un toque delicioso a tu buen rato.</div>
        <div class="sbtitle">No sólo cenar, sino experimentar la vida. Añade un toque delicioso a tu buen rato.</div>
      </div>

      <div class="img-box">
        <div class="img-item">
          <img src="../assets/home-11.png" alt="">
          <div class="text-box">
            <div>tiempo de fiesta</div>
            <p>Haga de cada reunión un recuerdo inolvidable y comparta un festín lleno de comida deliciosa y diversión con familiares y amigos.</p>
          </div>
        </div>
        <div class="img-item">
          <img src="../assets/home-12.png" alt="">
          <div class="text-box">
            <div>cena familiar</div>
            <p>Brindamos una variedad de opciones gastronómicas y proyectos de entretenimiento para garantizar que pueda pasar cada momento inolvidable con su familia y amigos y crear preciosos recuerdos familiares.</p>
          </div>
        </div>
        <div class="img-item">
          <img src="../assets/home-13.png" alt="">
          <div class="text-box">
            <div>Horas Laborales</div>
            <p>Proporcione una variedad de opciones gastronómicas y un ambiente de trabajo conveniente para garantizar que pueda sentirse cómodo y satisfecho incluso en su ajetreado trabajo.</p>
          </div>
        </div>
      </div>
    </div>

    <div class="choose-box">
      <div class="us-box">
        <img src="../assets/home-14.png" alt="">
      </div>
      <div class="us-box-title">
        <div class="text-1">¿Por qué elegirnos?</div>
        <div class="text-2">Seguro de calidad:</div>
        <div class="text-3">Ingredientes frescos y cocinados cuidadosamente, cada plato representa nuestro cuidado y compromiso.</div>
        <div class="text-2">Opciones ricas:</div>
        <div class="text-3">Desde cenas elegantes hasta comida rápida conveniente, podemos satisfacer sus diversas necesidades de gusto.</div>
      </div>
    </div>


    <footerBox></footerBox>
  </div>
</template>

<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
import 'swiper/css/swiper.min.css'

export default {
  name: 'App',
  components: {
    menuBox,
    footerBox,
    Swiper,
    SwiperSlide,
    directive
  },
  data() {
    return {
      name: '',
      address: '',
      pagination: {
        autoplay: true,
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          dynamicBullets: true
        },
      }
    }
  },
  mounted() {

  },
  methods: {
    SubmitOk() {
      if (!this.name) {
        return alert('please enter your name')
      } else if (!this.address) {
        return alert('please enter your email address')
      }
      alert('Submitted successfully')
    }
  }
}
</script>
<style lang="less" scoped>
.title {
  font-weight: 400;
  font-size: 50px;
  color: #333333;
}

.sbtitle {
  font-weight: 400;
  font-size: 22px;
  color: #656565;
  margin-top: 18px;
}

.home-box {
  height: 900px;
  background: url(../assets/home-1.png);
  background-size: 100% 100%;

  .text-box {
    font-weight: 400;
    font-size: 68px;
    color: #FFFFFF;
    text-align: center;
    width: 900px;
    margin: auto;
    margin-top: 200px;

    p {
      font-weight: 400;
      font-size: 22px;
      color: #FFA72C;
      margin-top: 20px;
    }

    .sb-text {
      font-weight: 400;
      font-size: 22px;
      color: #FFFFFF;
      margin-top: 20px;
    }
  }
}

.way-box {
  padding: 0px 360px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: -150px;

  .way-text {
    width: 600px;

    .way-info {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 40px;

        img {
          width: 60px;
          margin-right: 12px;
        }

        .item-text {
          width: 180px;

          div {
            font-weight: 400;
            font-size: 28px;
            color: #333333;
          }

          p {
            font-weight: 400;
            font-size: 20px;
            color: #888888;
          }
        }
      }
    }

    .gou-box {
      margin-top: 20px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      font-weight: 400;
      font-size: 24px;
      color: #333333;

      img {
        width: 26px;
        margin-right: 12px;
      }

    }
  }

  img {
    width: 540px;
  }
}

.cuisine-box {
  height: 2296px;
  background: url(../assets/home-10.png);
  background-size: 100% 100%;
  margin-top: 150px;
  text-align: center;
  padding: 0px 360px;

  .title {
    padding-top: 150px;
  }

  .ctetext {
    font-weight: 400;
    font-size: 22px;
    color: #FFA72C;
    margin-top: 20px;
  }

  .cuisine-list {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-top: 80px;

    .item {
      width: 265px;

      img {
        width: 265px;
      }

      div {
        font-weight: 400;
        font-size: 28px;
        color: #333333;
        margin-top: 40px;
      }

      p {
        font-weight: 400;
        font-size: 20px;
        color: #888888;
        margin-top: 8px;
      }
    }

    .item-box {
      margin-top: 110px;
    }
  }

  .text-list {
    padding: 40px;
    background: #F2A233;
    border-radius: 40px 40px 40px 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 180px;

    .info {
      div {
        font-weight: 400;
        font-size: 68px;
        color: #333333;
      }

      p {
        font-weight: 400;
        font-size: 24px;
        color: #333333;
        margin-top: 10px;
      }
    }
  }

  .text-title {
    margin-top: 150px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    div {
      width: 500px;
      margin: auto;
      padding: 0px;
      color: #FFF;
    }
  }

  .img-box {
    margin-top: 80px;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;

    .img-item {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;

      img {
        width: 380px;
      }

      .text-box {
        padding: 40px;
        width: 223px;
        background: rgba(15, 15, 15, 0.9);
        border-radius: 8px 8px 8px 8px;
        border: 1px solid #FFFFFF;
        position: absolute;
        z-index: 1;
        top: 80%;

        div {
          font-weight: 400;
          font-size: 28px;
          color: #FFFFFF;
        }

        p {
          font-weight: 400;
          font-size: 16px;
          color: #FFFFFF;
          margin-top: 15px;
        }
      }
    }
  }
}

.choose-box {
  padding: 350px 360px 350px 0px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .us-box {
    width: 741px;
    height: 550px;
    background: #F39B13;
    border-radius: 0px 0px 0px 0px;

    img {
      width: 550px;
      margin-top: 129px;
      margin-left: 361px;
    }
  }

  .us-box-title {
    width: 570px;

    .text-1 {
      font-weight: 400;
      font-size: 52px;
      color: #333333;
    }

    .text-2 {
      font-weight: 600;
      font-size: 24px;
      color: #333333;
      margin-top: 32px;
    }

    .text-3 {
      font-weight: 400;
      font-size: 18px;
      color: #333333;
      margin-top: 16px;
    }
  }
}
</style>
